import moment from "moment/moment";
import React from "react";
import { editorialCommentType, newsDisplayIsSummaryType } from "../../../common/types/search/news";

interface EditorialCommentProps {
	editorialComment: editorialCommentType;
	summary: newsDisplayIsSummaryType;
}

export function EditorialComment({
	editorialComment,
	summary,
}: EditorialCommentProps) {
	const value = editorialComment.get("value");

	if (summary || !value) {
		return null;
	}

	const date = editorialComment.get("date");
	const editorialDate = date && (
		<span>
			&nbsp;-&nbsp;{moment.utc(date).format("DD.MM.YYYY - HH:mm UTC")}
		</span>
	);

	return (
		<p className="post__editorial-comment">
			<b>Editorial Comment</b>: {value}
			{editorialDate}
		</p>
	);
}
